import React from 'react';
import { BOTTOM_INDENTS, COLORS } from '@constants';
import { usePolling, useStore } from '@hooks';
import { Typography } from '@ui';
import { Progress } from 'antd';
import { observer } from 'mobx-react';
import { METHODS } from '../../constants';
import SyncBanner from '../SyncBanner';
import { StyledFlex, StyledWrapper } from './styled';

const ProductsSyncProgress = observer(() => {
    const store = useStore();
    const { getAccountSyncProgress, productsSyncProgress = {}, isManual } = store.accountsStore;

    usePolling(getAccountSyncProgress, 1000, true);

    if (isManual) {
        return (
            <StyledWrapper>
                <SyncBanner method={METHODS.SYNC_PROGRESS} />
                <Typography.Text align='center' type='body2' color={COLORS.$gray60Black}>
                    <React.Fragment>
                        We are currently importing your product data. This usually takes a few minutes depending on the
                        size of your catalog. Your products will appear here automatically once the sync is complete.
                        Feel free to refresh the page or check back in a moment.
                    </React.Fragment>
                </Typography.Text>
            </StyledWrapper>
        );
    }

    return (
        <React.Fragment>
            <StyledFlex data-e2e='products_sync-products_section' align='center' justify='center' vertical>
                <Progress
                    data-e2e='products_sync_progress-circle'
                    type='circle'
                    percent={productsSyncProgress?.percentDone || 0}
                    style={BOTTOM_INDENTS.M}
                />
                <Typography.Title level={2} color={COLORS.$gray60Black} style={BOTTOM_INDENTS.M}>
                    Syncing your products...
                </Typography.Title>
                <Typography.Text align='center' type='body2' color={COLORS.$gray60Black} style={BOTTOM_INDENTS.M}>
                    {productsSyncProgress.progressCount} out of {productsSyncProgress.totalCount} products synchronized.{' '}
                    <br />
                    This may take a few minutes.
                </Typography.Text>
            </StyledFlex>
        </React.Fragment>
    );
});

export default ProductsSyncProgress;
